import { render, staticRenderFns } from "./UserGroupProgress.vue?vue&type=template&id=6425cdf4"
import script from "./UserGroupProgress.js?vue&type=script&lang=js&external"
export * from "./UserGroupProgress.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports